import { formatInTimeZone } from "date-fns-tz";

export const TIMEZONE_BRASIL = "America/Sao_Paulo";

/**
 * Formata instante ISO (com ou sem offset) no fuso PT-BR (America/Sao_Paulo).
 * Evita exibir horário UTC como se fosse local quando a API omite o offset.
 */
export function formatDateTimeBr(
  dateString: string | null | undefined,
  pattern = "dd/MM/yyyy HH:mm"
): string {
  if (!dateString) {
    return "Data não disponível";
  }

  const date = new Date(dateString);
  if (Number.isNaN(date.getTime())) {
    return dateString;
  }

  return formatInTimeZone(date, TIMEZONE_BRASIL, pattern);
}
